(function() {

    let app = angular.module('TetherApp');

    let CampaignIssueController = function (
        $window,
        $location,
        $anchorScroll,
        $scope
    ) {
        let self = this;
        self.campaignId = null;
        self.supportIssueId = null;
        self.campaignSupportIssues = [];
        self.clientSupportIssues = [];

        self.init = function (campaignId) {
            self.campaignId = campaignId;
            if(window.clientSupportIssues != undefined) { 
                angular.forEach(window.clientSupportIssues, function( value, key ) {
	                self.clientSupportIssues.push(value);
	            }, self);
            }
            if(window.campaignSupportIssues != undefined) {
				angular.forEach(window.campaignSupportIssues, function( value, key ) {
                    for (let i = 0; i < self.clientSupportIssues.length; i++) { 
                        if (self.clientSupportIssues[i].id == value.support_issue_id) {
                            value['name'] = self.clientSupportIssues[i].name;
                        }
                    }
	                self.campaignSupportIssues.push(value);
	            }, self);
        	}
            if (self.campaignSupportIssues.length > 0) {
                document.getElementById('dropdown-none').style.display = 'none';
            }
        };

        self.createAll = function () {
            self.clientSupportIssues.forEach(element => {
                self.createCampaignSupportIssue(element)
            })
        }

        self.createCampaignSupportIssue = function (_issue = null) {

            let issueId;
            if (_issue) {
                issueId = _issue.id
            } else {
                issueId = document.getElementById('support-issues').value;
            }

            let issue;
            for (let i = 0; i < self.clientSupportIssues.length; i++) {
                if (self.clientSupportIssues[i].id == issueId) {
                    issue = {
                        'support_issue_id': self.clientSupportIssues[i].id,
                        'name': self.clientSupportIssues[i].name
                    }

                    let match = false;
                    for (let j = 0; j < self.campaignSupportIssues.length; j++) {
                        if (self.campaignSupportIssues[j].support_issue_id == issue.support_issue_id) {
                            match = true;
                        }
                    }
                    if (!match){
                        self.campaignSupportIssues.push(issue);
                    }
                }
            }
            document.getElementById('dropdown-none').style.display = 'none';
        }

        self.toggleDropdownIssues = function() {
            let dropdownContent = document.getElementById('dropdown-content');
            let dropdownIcon = document.getElementById('dropdown-icon');
            if (dropdownContent.style.display == 'block') {
                dropdownContent.style.display = 'none';
                dropdownIcon.classList.remove('fa-chevron-down');
                dropdownIcon.classList.add('fa-chevron-left');
            }
            else {
                dropdownContent.style.display = 'block';
                dropdownIcon.classList.add('fa-chevron-down');
                dropdownIcon.classList.remove('fa-chevron-left');
            }
        }

        self.removeIssue = function(id) {
            let issue = self.campaignSupportIssues.find(element => element.support_issue_id == id);
            self.campaignSupportIssues.splice(self.campaignSupportIssues.indexOf(issue), 1);
            
            if (self.campaignSupportIssues.length <= 0) {
                document.getElementById('dropdown-none').style.display = 'block';
            }
        }
    };

    angular.module('TetherApp').controller('CampaignIssueController', [
        '$window',
        '$location',
        '$anchorScroll',
        '$scope',
        CampaignIssueController
    ]);
}());
